/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable, Optional } from '@angular/core';
import { Firm } from './firm.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UrlBuilderService } from '@irian-ro/abstract-resource';
import { Observable } from 'rxjs/index';
import { LazyLoadEvent } from 'primeng/api';
import { EnvironmentService } from '@irian-ro/util-environment';

@Injectable()
export class FirmService {
  private readonly url: string = '/api/firm';

  constructor(
    private readonly httpClient: HttpClient,
    @Optional() private readonly environmentService: EnvironmentService
  ) {
    if (this.environmentService && this.environmentService.getEnvironmentProperty('baseUrl')) {
      this.url = `${this.environmentService.getEnvironmentProperty('baseUrl')}/firm`;
    }
  }

  getFirms(event: LazyLoadEvent): Observable<Firm[]> {
    return this.httpClient.get<Firm[]>(UrlBuilderService.createUrlFromLazyLoadEvent(this.url, event));
  }

  getFirm(uuid: string): Observable<Firm> {
    const url = `${this.url}/${uuid}`;
    return <Observable<Firm>>this.httpClient.get<Firm>(url);
  }

  save(firm: Firm): Observable<Firm> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
    });
    return <Observable<Firm>>this.httpClient.post(this.url, JSON.stringify(firm), { headers: headers });
  }

  update(firm: Firm): Observable<Firm> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
    });
    return <Observable<Firm>>this.httpClient.put(this.url, JSON.stringify(firm), { headers: headers });
  }

  delete(uuid: string) {
    const url = `${this.url}/${uuid}`;
    this.httpClient.delete(url).subscribe({
      error: (error) => console.log(error),
    });
  }
}
